import { FC } from 'react'
import { EmpresaForm } from '../../../empresas-list/components/form/EmpresaForm'

export const ClientesModal: FC = () => {
  return <EmpresaForm mode='cliente' empresaMaeObrigatoria />
}
